<template>
  <!--
    Komponent wyświetlający wybrany typ statystyki (statName) jako filtr.
    Wyświetla tytuł sekcji i aktualnie wybraną nazwę statystyki.
  -->
  <div v-if="store.filters.statName" class="filter d-flex flex-column">
    <!--
      Nagłówek sekcji z tłumaczonym kluczem 'statistic-type'.
    -->
    <h5 class="margin-0">
      {{ t('statistic-type') }}
      <!--
        Można tu dodać ikonkę zwijania (collapse), jeśli była by potrzebna.
      -->
    </h5>
    <!--
      Blok z informacją o wybranej statystyce.
      Wyświetla nazwę statystyki pobraną ze store.statName za pomocą klucza store.filters.statName.
    -->
    <div class="info collapse show" id="statNameFilterView">
      <p v-if="store.filters.statName" class="margin-0">
        {{ store.statName[store.filters.statName] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatNameFilterView",  // Nazwa komponentu
  props: {
    // Oczekuje przekazania store zawierającego filtry i dane statName
    store: { required: true },
  },
};
</script>

<style scoped>
.filter {
  width: 100%;  /* Ustawia szerokość kontenera filtra na 100% */
}

.filter h5 {
  /* Styl nagłówka sekcji */
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}

.info {
  /* Styl bloku z informacją */
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
}

.info p {
  /* Styl paragrafu z nazwą statystyki */
  font-size: 12px;
}

.icon-collapse {
  /* Styl ikony zwijania (jeśli zostanie użyta) */
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}

.collapsed.icon-collapse {
  /* Styl ikony rozwinięcia */
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
